import React from 'react';
import Select, { components } from 'react-select';
import { Box, Checkbox, Text } from '@chakra-ui/react';

// Custom Option component to include checkbox
const CustomOption = (props) => {
  const { isSelected, label, data, selectOption } = props;

  const handleChange = () => {
    selectOption(data);
  };

  return (
    <components.Option {...props}>
      <Checkbox
        borderColor='gray.500'
        isChecked={isSelected}
        onChange={handleChange}
        mr={2}
        mt={1}
      />
      {label}
    </components.Option>
  );
};

// Custom MultiValue component is no longer needed as default suffices and is more stable

const MultiSelect = ({ options, placeholder, onChange, value, isMulti }) => {
  const customStyles = {
    control: (provided) => ({
      ...provided,
      minWidth: '200px',
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  // Handle change for options
  const handleChange = (selectedOption) => {
    onChange(selectedOption);
  };

  return (
    <Box
      w='100%'
      sx={{ position: 'relative' }}
      minWidth='200px'>
      <Select
        isMulti={isMulti}
        options={options}
        placeholder={placeholder}
        onChange={handleChange}
        closeMenuOnSelect={false}
        value={value}
        classNamePrefix='chakra-react-select'
        components={{
          Option: CustomOption,
        }}
        hideSelectedOptions={false} // Ensure options remain visible
        menuPortalTarget={document.body}
        menuPosition="fixed"
        styles={{
          ...customStyles,
          menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
        }}
      />
    </Box>
  );
};

export default MultiSelect;
